import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=9f8513cc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=9f8513cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8513cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f8513cc')) {
      api.createRecord('9f8513cc', component.options)
    } else {
      api.reload('9f8513cc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=9f8513cc&scoped=true&", function () {
      api.rerender('9f8513cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26cl9JfAy4Ydw/JS/teamMember.vue"
export default component.exports